/**
 * Helper/Reference to get scopes necessary to auth to ODSP
 *
 * @param odspServerTenant The base sharepoint server url, usually in form of '*.sharepoint.com' e.g. 'microsoft.sharepoint.com'
 * @returns Scopes to auth to ODSP
 */
export const getOdspScopes = (odspServerTenant) => [`https://${odspServerTenant}/AllSites.Write`];
/**
 * Helper/Reference to get scopes necessary to auth to PushChannel
 *
 * @returns Scopes to auth to PushChannel
 */
export const getPushChannelScope = () => 'https://pushchannel.1drv.ms/PushChannel.ReadWrite.All';
//# sourceMappingURL=odspClientConfig.js.map